export const REGISTER_URL = 'https://mrcuci.org/RFESTERSEO99';
